import Component from './component'
import withTranslation from '../../globals/components/withTranslation'

export default withTranslation(Component)
